<template>
  <div class="UITextEllipsis">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.UITextEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // `text-wrap` and `white-space` both control the `text-wrap-mode` longhand.
  // Font mixins (e.g. `font-body-*`) set `text-wrap: pretty`, which can load
  // later in the cascade and silently re-enable wrapping. Force it back off.
  text-wrap: nowrap !important;
}
</style>
